import React from "react";

import { useIntl } from "react-intl";

import { useWindowWidth } from "hooks";
import { CustomModal } from "components/base";
import m from "definedMessages";


import { FlexboxGrid } from "rsuite";

export default ({ maxWidth = 600, show, onClose, loading, formatMessage, ...props }) => {
    const resizedWidth = useWindowWidth();

    return (
        <CustomModal
            show={show}
            onClose={() => onClose()}
            title={formatMessage(m.revokeNumbers)}
            width={resizedWidth > maxWidth ? maxWidth : resizedWidth}
            showFooter={true}
            confirmButtonText={formatMessage(m.yes)}
            focusTarget="close"
            loading={loading}
            onConfirm={props.onSuccess}
        >
            <FlexboxGrid justify="end">
                <FlexboxGrid.Item colspan={23}>
                    <span>{formatMessage(m.numbersWillBeRevoked, { count: props.getCount() })} </span>
                </FlexboxGrid.Item>
            </FlexboxGrid>

        </CustomModal>
    );
};